module.exports = __webpack_public_path__ + "fonts/Montserrat-ThinItalic.3cb6211.ttf";